export const reArrangePermissions = (permissions) => {
  const reArrangedPermissions = {};
  if(permissions && permissions.length > 0) {
    
    for (const permission of permissions) {
      if(!reArrangedPermissions[permission.module]) {
        reArrangedPermissions[permission.module] = [];
      }
      
      reArrangedPermissions[permission.module].push(permission.access);
    }
  }
  return reArrangedPermissions;
}

export const extractPermissions = (permissions) => {
  const allowedCampaign = [];
  const allowedInterview = [];
  if(permissions && permissions.length > 0) {
    for (const permission of permissions) {
      if (permission.module === "campaign") {
        allowedCampaign.push(permission.access);
      }
      if (permission.module === "interview") {
        allowedInterview.push(permission.access);
      }
    }
  }
  return {
    campaign: allowedCampaign,
    interview: allowedInterview,
  }
}